<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('products')">
            <app-default-button
                    :title="$addLabel('product')"
                    @click="openModal"
            />
        </app-page-top-section>

        <app-table id="products-table"
                   :options="options"
                   @action="triggerActions"
        />

        <app-product-create-edit
                v-if="isModalActive"
                v-model="isModalActive"
                :selected-url="selectedUrl"
        />

        <app-confirmation-modal
                v-if="confirmationModalActive"
                icon="trash-2"
                modal-id="app-confirmation-modal"
                @confirmed="confirmed('products-table')"
                @cancelled="confirmationModalActive = false"
        />

        <app-confirmation-modal
                v-if="statusModal"
                icon="activity"
                modal-id="app-status-confirmation-modal"
                :subTitle="''"
                :message="statusMessage"
                @confirmed="updateStatus('products-table')"
                @cancelled="statusModal = false"
        />
    </div>
</template>

<script>
    import ProductMixins from "../../Mixins/ProductMixins";
    import {axiosPatch, urlGenerator} from "../../../Helpers/AxiosHelper";
    import {PRODUCTS} from "../../../Config/ApiUrl";

    export default {
        name: "Products",
        mixins: [ProductMixins],
        data() {
            return {
                statusModal: false,
                statusMessage: '',
                product_slug: null,
            }
        },
        methods: {
            openModal() {
                this.isModalActive = true;
                this.selectedUrl = null;
            },
            updateStatus(id) {
                axiosPatch(urlGenerator(`${PRODUCTS}/${this.product_slug}/change-status`))
                    .then(response => {
                        this.toastAndReload(response.data.message, id)
                    })
            }
        }
    }
</script>

<style scoped>

</style>